import {getDistanceFromPointToLine} from "./sqftHelper";
import {getAngleBetween3Points} from "./shapeHelper";

export default class FitSize {

  shape;
  line;
  nextLine;
  prevLine;
  outlineDistance = 0;

  constructor(line) {
    this.line = line;
    this.shape = line.getParent();
    this.nextLine = this.shape.getNextLine(line);
    this.prevLine = this.shape.getPrevLine(line);
  }

  isFitSize = (additionalLength) => {
    return [
      this.isFitLineLength(additionalLength),
      this.isFitSiblingLineCorner(additionalLength),
      this.isFitBumpout(additionalLength),
      this.isFitPontDistancesToCornerLine(additionalLength),
      this.isFitByAngleBetweenLines(additionalLength)
    ]
      .every(isFit => isFit)
  };

  isFitPontDistancesToCornerLine = (additionalLength) => {
    const prevPointToCurrentLineLength = getDistanceFromPointToLine(
      this.prevLine.from.x,
      this.prevLine.from.y,
      this.line.from.x,
      this.line.from.y,
      this.line.to.x,
      this.line.to.y,
    )
    const nextPointToCurrentLineLength = getDistanceFromPointToLine(
      this.line.to.x,
      this.line.to.y,
      this.prevLine.from.x,
      this.prevLine.from.y,
      this.prevLine.to.x,
      this.prevLine.to.y,
    )

    return [prevPointToCurrentLineLength, nextPointToCurrentLineLength].every((lineLength) => {
      return additionalLength + this.outlineDistance <= lineLength
    })
  }

  isFitLineLength = (additionalLength) => {
    return [this.line.getLineLength(), this.prevLine.getLineLength()].every((lineLength) => {
      return additionalLength <= lineLength
    })
  };

  isFitSiblingLineCorner = (additionalLength) => {
    let siblingCornerLength = 0;
    let cornerTotalLength = 0;

    if (this.nextLine.from.arcLength > 0 || this.nextLine.from.angle > 0) {
      siblingCornerLength = this.nextLine.from.getArcLength() || this.nextLine.from.getAngle();
      cornerTotalLength = +siblingCornerLength + +additionalLength;
      if(cornerTotalLength >= this.line.getLineLength()) {
        return false
      }
    }
    if (this.prevLine.from.arcLength > 0 || this.prevLine.from.angle > 0) {
      siblingCornerLength = this.prevLine.from.getArcLength() || this.prevLine.from.getAngle();
      cornerTotalLength = +siblingCornerLength + +additionalLength;
      if(cornerTotalLength >= this.prevLine.getLineLength() ) {
        return false
      }
    }

    return true
  };

  isFitBumpout = (additionalLength) => {
    if(this.line.isWithBumpout()){
      let bumpoutTextParameters = this.line.bumpoutOverlay.getBumpoutTextParameter();

      if(additionalLength >= bumpoutTextParameters.length4to.pointsDistance) {
        return false
      }
    } else if(this.prevLine.isWithBumpout()){
      let bumpoutTextParameters = this.prevLine.bumpoutOverlay.getBumpoutTextParameter();

      if(additionalLength >= bumpoutTextParameters.length4to.pointsDistance) {
        return false
      }
    }

    return true
  };

  isFitByAngleBetweenLines = (radius) => {
    const angle = getAngleBetween3Points(
      this.prevLine.from, this.line.from, this.line.to
    );

    // d = r/tan(α/2)
    const minDistanceNeeded = radius / Math.tan((angle / 2) * (Math.PI / 180));

    const prevLineLength = this.prevLine.getLineLength();
    const lineLength = this.line.getLineLength();

    return prevLineLength >= minDistanceNeeded && lineLength >= minDistanceNeeded;
  };
}
